import { render } from "./GroupFormUser.vue?vue&type=template&id=f7ec240a"
import script from "./GroupFormUser.vue?vue&type=script&lang=js"
export * from "./GroupFormUser.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__